import React from "react";

// A stale cross-app link does a full browser navigation into this app's
// bundle. If a deploy rotated the chunk hashes since this tab last loaded
// anything here, a lazy-loaded route's dynamic import() 404s and throws -
// Suspense only handles the *pending* state, not a rejected import, so
// without a boundary that throw unmounts the whole tree and leaves a blank
// page.
const isChunkLoadError = (error) =>
  /Loading chunk|dynamically imported module|Failed to fetch/i.test(
    error?.message || ""
  );

const RELOAD_FLAG = "errorBoundary:reloadedForChunkError";

class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    if (isChunkLoadError(error) && !sessionStorage.getItem(RELOAD_FLAG)) {
      // Self-heal once: refetch index.html and the current chunk manifest.
      sessionStorage.setItem(RELOAD_FLAG, "1");
      window.location.reload();
    }
  }

  handleReload = () => {
    sessionStorage.removeItem(RELOAD_FLAG);
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div
        role="alert"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "12px",
          height: "100vh",
          textAlign: "center",
          padding: "24px",
        }}
      >
        <p style={{ fontSize: "16px", fontWeight: 600 }}>
          Something went wrong loading this page.
        </p>
        <p style={{ color: "#717171" }}>
          Please reload to try again.
        </p>
        <button
          type="button"
          onClick={this.handleReload}
          className="button is-primary is-rounded"
        >
          Reload
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
